import Vue from 'vue'
import Router from 'vue-router'

import { loadLanguageAsync } from '../plugins/i18n'

import ClienteLayout from '@layouts/ClienteLayout.vue'
import Inicio from '@pages/Inicio.vue'
import DetallesIndicador from '@pages/DetallesIndicador.vue'
import ListadoIndicadores from '@pages/ListadoIndicadores.vue'
import ListadoHashtags from '@pages/ListadoHashtags.vue'
import Informacion from '@pages/Informacion.vue'
import EstadoAgenda from '@pages/EstadoAgenda.vue'
import Favoritos from '@pages/Favoritos.vue'
import InfoCookies from '@pages/InfoCookies.vue'
import InfoPrivacidad from '@pages/InfoPrivacidad.vue'
import SubirIndicadores from '@pages/SubirIndicadores.vue'
import Pagina404 from '@pages/Pagina404.vue'
import TestGraficas from '@pages/TestGraficas.vue'

Vue.use(Router);


const routes = [

    {
        path: '/subir-indicadores',
        component: SubirIndicadores,
    },
    {
        path: '/test-graficas',
        component: TestGraficas,
    },
    {
        path: '/:locale',
        component: ClienteLayout,
        children: [
            {
                name: 'inicio',
                path: '',
                component: Inicio

            },
            {
                name: 'listado-indicadores',
                path: 'indicadores',
                component: ListadoIndicadores
            },
            {
                name: 'estado-agenda',
                path: 'estado-agenda',
                component: EstadoAgenda
            },
            {
                name: 'detalles',
                path: 'indicadores/:id',
                props: true,
                component: DetallesIndicador
            },
            {
                name: 'objetivo-indicadores',
                path: 'indicadores/objetivo/:id',
                props: true,
                component: ListadoIndicadores
            },
            {
                name: 'hashtag-indicadores',
                path: 'indicadores/hashtag/:id',
                props: true,
                component: ListadoHashtags
            },

            {
                name: 'informacion',
                path: 'informacion',
                component: Informacion,
            },
            {
                name: 'favoritos',
                path: 'favoritos',
                component: Favoritos,
            },
            {
                name: 'cookies',
                path: 'cookies',
                component: InfoCookies,
            },
            {
                name: 'privacidad',
                path: 'privacidad',
                component: InfoPrivacidad,
            },
            { path: ':pathMatch(.*)*', name: 'NotFound', component: Pagina404 },
        ],

    },

];

let routerInstance = new Router({
    mode: 'history',
    routes
});

//Pedimos que traiga el .json con el idioma en cada llamada.
routerInstance.beforeEach((to, from, next) => {
    const lang = to.params.locale ?? 'va';
    loadLanguageAsync(lang).then(() => next())
});

export default routerInstance;
